// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1YVkv","item":"PaymentsMobile_item__1IOrk","label":"PaymentsMobile_label__3RfRV","amount":"PaymentsMobile_amount__wwyOy"};